"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var MonthDropdownOptions = /** @class */ (function (_super) {
    __extends(MonthDropdownOptions, _super);
    function MonthDropdownOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderOptions = function () {
            var selectedMonth = _this.props.month;
            return _this.props.monthNames.map(function (month, i) { return (React.createElement("div", { className: "ee_react-datepicker__month-option", key: month, onClick: _this.onChange.bind(_this, i) },
                selectedMonth === i ? (React.createElement("span", { className: "ee_react-datepicker__month-option--selected" }, "\u2713")) : (''),
                month)); });
        };
        _this.onChange = function (month) {
            _this.props.onChange(month);
        };
        _this.handleClickOutside = function () {
            _this.props.onCancel();
        };
        return _this;
    }
    MonthDropdownOptions.prototype.render = function () {
        return (React.createElement("div", { className: "ee_react-datepicker__month-dropdown" }, this.renderOptions()));
    };
    MonthDropdownOptions.displayName = 'MonthDropdownOptions';
    MonthDropdownOptions.propTypes = {
        onCancel: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        month: PropTypes.number.isRequired,
        monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
    };
    return MonthDropdownOptions;
}(React.Component));
exports.MonthDropdownOptions = MonthDropdownOptions;
exports.default = MonthDropdownOptions;
//# sourceMappingURL=month_dropdown_options.js.map
